"use client";

import { walletTelemetry, type WalletTelemetryInput } from "@mudwater/sdk";
import { useEffect } from "react";

import { identifyFaroUser, rumEvent } from "@/lib/faro";

/**
 * Names the holder in Faro by their Solana address. Shared by both bridges:
 * it is observability, not authentication, so it has nothing to do with which
 * wallet supplied the address.
 */
export function useIdentifyWallet(
  solanaAddress: string | null,
  wallet?: WalletTelemetryInput | null
) {
  const {
    solana_provider,
    solana_source,
    wallet_advertised_versions,
    app_supported_versions,
  } = walletTelemetry(wallet);
  useEffect(() => {
    identifyFaroUser(solanaAddress);
    // The end of a connect: Glyph's login and a wallet's approval land here.
    if (solanaAddress)
      rumEvent("wallet_connected", {
        chain: "solana",
        solana_provider,
        solana_source,
        wallet_advertised_versions,
        app_supported_versions,
      });
    return () => identifyFaroUser(null);
  }, [
    solanaAddress,
    solana_provider,
    solana_source,
    wallet_advertised_versions,
    app_supported_versions,
  ]);
}
